<template>
    <x-form ref="form">
        <x-container fluid grid-list-lg>
            <x-layout>
                <x-flex xs12>
                    <h2>Assign user to client</h2>
                </x-flex>
            </x-layout>

            <x-layout>
                <x-flex xs12>
                    <x-autocomplete
                        v-model="client_company_id"
                        :items="client_companies"
                        label="Client"
                        placeholder="Client"
                        item-text="name"
                        item-value="id"
                        :rules="[v => ruleRequired(v, 'Client')]"
                        append-icon="keyboard_arrow_down"
                        outline
                    />

                    <x-autocomplete
                        v-model="broker_user_id"
                        :items="broker_users"
                        label="User"
                        placeholder="User"
                        item-text="name"
                        item-value="id"
                        :rules="[v => ruleRequired(v, 'User')]"
                        append-icon="keyboard_arrow_down"
                        outline
                    />
                </x-flex>
            </x-layout>

            <x-layout>
                <x-flex xs12 text-xs-right>
                    <x-btn
                        class="ma-0"
                        color="tertiary"
                        @click="$emit('close')"
                    >
                        Cancel
                    </x-btn>

                    <x-btn
                        class="ma-0"
                        color="primary"
                        @click="save"
                    >
                        Submit

                        <i class="material-icons ml-2">trending_flat</i>
                    </x-btn>
                </x-flex>
            </x-layout>
        </x-container>
    </x-form>
</template>

<script>
    import rules from '~/mixins/rules';

    export default {
        name: "NewClientAssignment",

        mixins: [rules],

        data: function () {
            return {
                broker_user_id: null,
                client_company_id: null,
                client_companies: [],
                broker_users: []
            }
        },
        async mounted() {
            this.client_companies = (await axios.get(this.$root.api('client'))).data.data;
            this.broker_users = (await axios.get(this.$root.api('users'))).data.data;
        },
        methods: {
            save() {
                if (!this.$refs.form.validate()) { return }
                axios.post(
                    this.$root.api('broker/client-assignment'), {
                        broker_user_id: this.broker_user_id,
                        client_company_id: this.client_company_id,
                    })
                .then(res => {
                    this.$emit('assignment-added');
                    this.$emit('close');
                });
            },
        }
    }
</script>
